import { render, staticRenderFns } from "./AiModels.vue?vue&type=template&id=34c173e9&scoped=true&"
import script from "./AiModels.vue?vue&type=script&lang=js&"
export * from "./AiModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c173e9",
  null
  
)

export default component.exports